// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideTerminal as RawLucideTerminal } from "lucide-react";
export const LucideTerminal = /* @__PURE__ */ createIcon(RawLucideTerminal, "LucideTerminal", 2);
